import React from 'react'
import SessionDetails from '../components/Details/SessionDetails'
import NavBar from '../components/Navbar/NavBar'
import Footer from '../components/Footer/Footer'

function SessionDetail() {
  return (
    <div>
        <NavBar/>
        <SessionDetails/>
        <Footer/>

    </div>
  )
}

export default SessionDetail